import { DefaultFieldKeys } from 'ExportDialog/Constants';
export const EXPORT_LANGUAGE_KEY = 'language';
export const EXPORT_EMAIL_KEY = DefaultFieldKeys.EMAIL;
export const EXPORT_FORMAT_KEY = DefaultFieldKeys.FORMAT;